// @flow

import { ReduxAsyncAction } from '../support/utils';
import dash_api from '../support/dash_api';
import NotificationActions from './NotificationActions';

const GOOGLE_ROUTE = '/v1/google';

const GetAdWordsAccounts = new ReduxAsyncAction('GOOGLE_ADWORDS_GET_ACCOUNTS');
GetAdWordsAccounts.registerRequest(() => {
  return dash_api.get(`${GOOGLE_ROUTE}/get-accounts`).then(({ data }) => {
    return { accounts: data };
  });
});

export const GET_GOOGLE_ACCOUNTS = GetAdWordsAccounts.constants;
export const getAdWordsAccounts = GetAdWordsAccounts.request;

/* ------------------------------------------------------
 The following actions are used in the AdPartnerReducer
 instead of the GoogleReducer.
-------------------------------------------------------- */
const SaveAdWordsOnboarding = new ReduxAsyncAction('GOOGLE_ADWORDS_SAVE');
SaveAdWordsOnboarding.registerRequest(toSave => {
  return dash_api
    .post(`${GOOGLE_ROUTE}/save`, { ...toSave })
    .then(({ data }) => {
      data.neverConfigured = false;

      NotificationActions.showNotification(
        `Google AdWords has been saved and enabled`,
        'success'
      );

      return data;
    });
});

export const GOOGLE_ADWORDS_SAVE = SaveAdWordsOnboarding.constants;
export const saveAdWordsOnboarding = SaveAdWordsOnboarding.request;

const GetAdWordsUserInfo = new ReduxAsyncAction('GOOGLE_ADWORDS_GET_USER_INFO');
GetAdWordsUserInfo.registerRequest(() => {
  return dash_api.get(`${GOOGLE_ROUTE}/get-user-info`).then(({ data }) => {
    return data;
  });
});

export const GET_GOOGLE_USER_INFO = GetAdWordsUserInfo.constants;
export const getAdWordsUserInfo = GetAdWordsUserInfo.request;

const RevokeGoogleAuth = new ReduxAsyncAction('GOOGLE_ADWORDS_REVOKE_AUTH');
RevokeGoogleAuth.registerRequest(() => {
  return dash_api.post(`${GOOGLE_ROUTE}/revoke-auth`).then(({ data }) => data);
});

export const REVOKE_GOOGLE_AUTH = RevokeGoogleAuth.constants;
export const revokeGoogleAuth = RevokeGoogleAuth.request;
